import { ulid } from "@/schemas/commonFields";
import { updatePayrollAggregate } from "@/schemas/payrollAggregate";
import { updatePayrollDepartmentBasedInspection } from "@/schemas/payrollDepartmentBasedInspection";
import { updatePayrollRoleBasedInspection } from "@/schemas/payrollRoleBasedInspection";
import { updatePayrollSplits } from "@/schemas/payrollSplit";
import { z } from "@/zod";

export const writePayrollDepartmentBasedInspectionFormSchema = z.object({
  entries: z.record(ulid, updatePayrollDepartmentBasedInspection),
});

export const writePayrollRoleBasedInspectionFormSchema = z.object({
  entries: z.record(ulid, updatePayrollRoleBasedInspection),
});

export const writePayrollAggregateFormSchema = z.object({
  entries: z.record(ulid, updatePayrollAggregate),
});

export const writePayrollSplitFormSchema = z.object({
  entries: z.record(ulid, updatePayrollSplits),
});

export const updatePayrollDepartmentBasedInspectionDetailsFormSchema =
  updatePayrollDepartmentBasedInspection.omit({
    id: true,
  });

export const updatePayrollRoleBasedInspectionDetailsFormSchema =
  updatePayrollRoleBasedInspection.omit({
    id: true,
  });

export const updatePayrollAggregateDetailsFormSchema =
  updatePayrollAggregate.omit({
    id: true,
  });

export const updatePayrollSplitDetailsFormSchema = updatePayrollSplits.omit({
  id: true,
});

export const createPayrollInspectionFromAssignmentsSchema = z.object({
  selectedAssignmentIds: z.record(z.string(), z.boolean()),
});
